import { render } from "./DropdownQuickEdit.vue?vue&type=template&id=542c192f"
import script from "./DropdownQuickEdit.vue?vue&type=script&lang=js"
export * from "./DropdownQuickEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__